import { create } from 'zustand';

interface QueueState {
  isInQueue: boolean;
  isInQuickQueue: boolean;
  isSearching: boolean;
  matchToken: string | null;
  showMatchDialog: boolean;
  matchOpponent: string | null;
  timeRemaining: number;
  acceptedMatch: boolean;
  setIsInQueue: (value: boolean) => void;
  setIsInQuickQueue: (value: boolean) => void;
  setIsSearching: (value: boolean) => void;
  setMatchToken: (token: string | null) => void;
  setShowMatchDialog: (value: boolean) => void;
  setMatchOpponent: (opponent: string | null) => void;
  setTimeRemaining: (time: number | ((prev: number) => number)) => void;
  setAcceptedMatch: (value: boolean) => void;
  resetQueue: () => void;
  resetMatchDialog: () => void;
}

export const useQueueStore = create<QueueState>((set) => ({
  isInQueue: false,
  isInQuickQueue: false,
  isSearching: false,
  matchToken: null,
  showMatchDialog: false,
  matchOpponent: null,
  timeRemaining: 30,
  acceptedMatch: false,
  setIsInQueue: (value) => set({ isInQueue: value }),
  setIsInQuickQueue: (value) => set({ isInQuickQueue: value }),
  setIsSearching: (value) => set({ isSearching: value }),
  setMatchToken: (token) => set({ matchToken: token }),
  setShowMatchDialog: (value) => set({ showMatchDialog: value }),
  setMatchOpponent: (opponent) => set({ matchOpponent: opponent }),
  setTimeRemaining: (time) => set((state) => ({ 
    timeRemaining: typeof time === 'function' ? time(state.timeRemaining) : time 
  })),
  setAcceptedMatch: (value) => set({ acceptedMatch: value }),
  resetQueue: () => set({ 
    isInQueue: false,
    isInQuickQueue: false,
    isSearching: false,
    matchToken: null
  }),
  resetMatchDialog: () => set({ 
    showMatchDialog: false,
    matchOpponent: null,
    timeRemaining: 30,
    acceptedMatch: false 
  }),
}));